"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var unflatten = function (input, splitter) {
    var key, parts, t;
    if (splitter == null) {
        splitter = '__';
    }
    var output = {};
    for (var k in input) {
        t = output;
        parts = k.split(splitter);
        key = parts.pop() || '';
        while (parts.length) {
            var part = parts.shift() || '';
            t = t[part] = t[part] || {};
        }
        t[key] = input[k];
    }
    return output;
};
exports.default = unflatten;
